<template>
  <div>
    <a-card style="margin-top:20px;">
      <TableView
        :columns="tableColumns"
        tableCardTitle="CRM REPORT"
        :scroll="{ x: 800 }"
        :data="tableData"
      >
        <template v-slot:radio="{ tableRow }">
          <a-radio-group v-model="value" @change="onChange">
            <a-radio :value="tableRow.businessId"></a-radio>
          </a-radio-group>
        </template>
      </TableView>
      <a-button type="primary" @click="handleSubmit">
        提交
      </a-button>
    </a-card>
  </div>
</template>
<script>
import { TableView } from 'lxfintech-fe'
import { mapGetters } from 'vuex'
import { getCrmDetail } from '../../api'
export default {
  name: 'crm-report',

  data() {
    const tableColumns = [
      {
        width: 30,
        dataIndex: 'radio',
        title: '',
        scopedSlots: { customRender: 'radio' },
      },
      {
        width: 130,
        title: 'Business ID',
        dataIndex: 'businessId',
      },
      {
        width: 170,
        title: 'Business Name',
        dataIndex: 'primaryBusinessName',
      },
      {
        width: 220,
        title: 'Address 1',
        dataIndex: 'address1',
      },
      {
        width: 220,
        title: 'Address 2',
        dataIndex: 'address2',
      },
      {
        width: 130,
        title: 'City',
        dataIndex: 'cityName',
      },
      {
        width: 130,
        title: 'State',
        dataIndex: 'stateCode',
      },
      {
        width: 140,
        title: 'Postal Code',
        dataIndex: 'postalCode',
      },
      {
        width: 140,
        title: 'Country',
        dataIndex: 'countryName',
      },
      {
        width: 130,
        title: 'Country Code',
        dataIndex: 'countryCode',
      },
      {
        width: 180,
        title: 'Phone Number',
        dataIndex: 'phoneNumber',
      },
      {
        width: 130,
        title: 'Ticker Symbol',
        dataIndex: 'tickerSymbol',
      },
      {
        width: 130,
        title: 'Stock Exchange',
        dataIndex: 'stockExchange',
      },
      {
        width: 150,
        title: 'CIK Number',
        dataIndex: 'cikNumber',
      },
      {
        width: 160,
        title: 'Latest Statement Date',
        dataIndex: 'latestStatementDate',
      },
      {
        width: 130,
        title: 'Employees',
        dataIndex: 'employees',
      },
      {
        width: 170,
        title: 'Employees As Of Date',
        dataIndex: 'employeesAsOfDate',
      },
      {
        width: 130,
        title: 'Market Cap',
        dataIndex: 'marketCap',
      },
      {
        width: 190,
        title: 'Business Name Of Match',
        dataIndex: 'businessNameOfMatch',
      },
      {
        width: 180,
        title: 'Address 1 Of Match',
        dataIndex: 'address1OfMatch',
      },
      {
        width: 180,
        title: 'Address 2 Of Match',
        dataIndex: 'address2OfMatch',
      },
      {
        width: 130,
        title: 'City Of Match',
        dataIndex: 'cityNameOfMatch',
      },
      {
        width: 160,
        title: 'Postal Code Of Match',
        dataIndex: 'postalCodeOfMatch',
      },
      {
        width: 170,
        title: 'Country Code Of Match',
        dataIndex: 'countryCodeOfMatch',
      },
      {
        width: 175,
        title: 'Phone Number Of Match',
        dataIndex: 'phoneNumberOfMatch',
      },
      {
        width: 160,
        title: 'Fax Number Of Match',
        dataIndex: 'faxNumberOfMatch',
      },
    ]
    return {
      radio: '',
      value: '',
      tableData: [],
      tableColumns,
    }
  },
  components: {
    TableView,
  },
  computed: {
    ...mapGetters('app', ['bureauReportBasicInfo']),
  },
  mounted() {
    this._getCrmDetail()
  },
  methods: {
    onChange(e) {
      this.radio = e.target.value
    },
    handleSubmit() {
      if (this.radio) {
        this.$router.push({
          name: 'mechanism-report-add',
          params: { customerId: this.$route.params.id },
          query: {
            businessId: this.radio,
          },
        })
      } else {
        this.$message.warning('请选择')
      }
    },
    async _getCrmDetail() {
      try {
        const { id } = this.bureauReportBasicInfo
        const { data } = await getCrmDetail(id)
        this.tableData = data
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>
